import React from "react";

function ShareIconBold() {
  return (
    <span className="anticon ant-share">
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 21 17"
        >
        <path
            fill="currentColor"
            fillRule="nonzero"
            stroke="currentColor"
            strokeWidth="0.8"
            d="M1.151 16.134c.193.082.416.04.566-.105 2.567-2.478 5.941-3.894 9.551-4.019v3.644a.524.524 0 00.522.522.523.523 0 00.368-.153l7.305-7.305a.521.521 0 000-.738L12.158.676a.52.52 0 00-.89.369v3.664C5.468 4.982.833 9.787.833 15.654c0 .209.125.398.318.48zM11.79 5.74a.522.522 0 00.521-.522V2.305l6.045 6.044-6.045 6.045V11.48a.52.52 0 00-.521-.522c-3.64 0-7.087 1.223-9.838 3.468C2.56 9.536 6.74 5.74 11.79 5.74z"
        ></path>
        </svg>
    </span>
  );
}

export default ShareIconBold;
